import {api} from './../api'
import router from './../router'

const CLIENT_ID = 1

export const user = {
  namespaced: true,
  state: {
    session: {
      access_token: null,
      expires_in: null,
      refresh_token: null,
      token_type: null,
      logged_at: null
    },
    user: {
      id: null,
      name: null,
      email: null,
      organizations: []
    },
    activeOrganization: null,
    loginError: {}
  },
  getters: {
    isLogged(state) {
      return state.user.id != null
    },
    getToken(state) {
      return state.session.access_token
    }
  },
  mutations: {
    updateUser(state, val) {
      state.user = val
    },
    updateSession(state, val) {
      state.session = val
    },
    setActiveOrganization(state, val) {
      state.activeOrganization = val
    },
    setLoginError(state, val) {
      state.loginError = val
    }
  },
  actions: {
    async login({commit, dispatch}, data) {
      commit('setLoginError', {})
      try {
        const res = await api.post('/auth', {
          client_id: CLIENT_ID,
          recaptcha: data.recaptcha_token,
          username: data.form.email,
          password: data.form.password,
        })

        commit('updateSession', {
          ...res.data,
          logged_at: new Date().getTime(),
        })

        dispatch('updateUser', {...data, login: true})

      } catch(e) {
        if (e.response && e.response.data) {
          const message = e.response.data.message || e.response.data.error
          commit('setLoginError', {force: false, message})
        } else {
          console.error(e)
          commit('setLoginError', {force: false, message: 'Wystąpił błąd podczas logowania.'})
        }
      }
    },
    async refreshToken({commit, state, dispatch}) {
      try {
        const refresh_token = state.session.refresh_token

        const res = await api.put('/auth', {
          client_id: CLIENT_ID,
          refresh_token
        })

        commit('updateSession', {
          ...res.data,
          logged_at: new Date().getTime()
        })

        dispatch('watchForTokenExpires')

      } catch(e) {
        console.log(e.response.data);
      }
    },
    watchForTokenExpires({dispatch, state}) {
      const expiresDate = state.session.expires_in + state.session.logged_at
      const now = new Date().getTime()

      const diff = expiresDate - now - 60000
      console.log(diff);

      setTimeout(() => {
        dispatch('refreshToken')
      }, diff)
    },
    async updateUser({commit, state, dispatch}, data = {}) {
      // Uzyskiwanie danych usera
      try {
        const user = await api.get('/user')

        commit('updateUser', {
          ...user.data
        })

        if(state.user.organizations.length == 0)
          router.replace({name: 'join-organization', params: {nextURL: data.nextURL}})
        else {
          if(data.login) {
            const default_organization = user.data.default_organization || state.user.organizations[0].id
            router.replace(data.nextURL || '/docs')
            dispatch('setActiveOrganization', default_organization)
          }
        }
      } catch(e) {
        console.error(e);
      }
    },
    async logout({commit}) {
      commit('updateSession', {
        access_token: null,
        expires_in: null,
        refresh_token: null,
        token_type: null,
        logged_at: null
      })
      commit('updateUser', {
        id: null,
        name: null,
        email: null,
        organizations: []
      })
      commit('setActiveOrganization', null)
      commit('hideNav', null, {root: true})

      router.replace('/login')
    },
    async setActiveOrganization({commit, state}, target) {
      if (!state.user.organizations.find((el) => el.id === target)) {
        console.error('Organization does not exist!')
        target = state.user.organizations[0].id
      }

      commit('setActiveOrganization', target)

      try {
        await api.put(`user/organizations/${target}`)
      } catch(e) {
        console.error(e)
      }
    }
  }
}
